import NavigationFooter from '../blocks/navigation-footer/NavigationFooter';
import NavigationMain from '../blocks/navigation-main/NavigationMain';

import { useEffect, useRef } from 'react';
import { fontSeasonSans, fontSeasonMix } from '../lib/fonts';

export default function SiteLayout({
  children,
  globalData,
  className = '',
  isDraftModeEnabled = false,
}) {
  const pageWrapperRef = useRef(null);

  useEffect(() => {
    const pageWrapper = pageWrapperRef.current;

    if (!pageWrapper) return;

    let ticking = false;
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;

          if (currentScrollY > 100) {
            pageWrapper.classList.add('scrolled');
          } else {
            pageWrapper.classList.remove('scrolled');
          }

          if (currentScrollY > lastScrollY) {
            pageWrapper.classList.add('scroll-down');
            pageWrapper.classList.remove('scroll-up');
          } else if (currentScrollY < lastScrollY) {
            pageWrapper.classList.add('scroll-up');
            pageWrapper.classList.remove('scroll-down');
          }

          lastScrollY = currentScrollY;
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      pageWrapper.classList.remove('scrolled', 'scroll-down', 'scroll-up');
    };
  }, []);

  return (
    <div
      ref={pageWrapperRef}
      className={`pageWrapper ${fontSeasonSans.variable} ${fontSeasonMix.variable}`}
      id="page"
    >
      <a href="#main-content" className="visuallyHidden-focusable">
        Skip to main content
      </a>
      {isDraftModeEnabled ? (
        <div className="preview-warning">
          <div className="l-grid">
            <div className="l-grid__col">
              <p>
                You are viewing a preview version of the site, to return to the
                live site please click <a href="/api/disable-preview">here</a>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <header className="mainHeader" id="header">
          {globalData && <NavigationMain block={globalData.navigationMain} />}
        </header>
      )}
      <main id="main-content">{children}</main>
      {/* <NavigationFooter block={globalData.navigationFooter} /> */}
    </div>
  );
}
